"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.position = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29844611085;
const slug = exports.slug = 'guides/cms/content/data-driven-content/serverless-functions/overview';
// translate-ignore
const navTitle = exports.navTitle = 'Overview';
const title = exports.title = 'Serverless functions for the CMS';
const name = exports.name = 'Serverless functions for the CMS';
const metaDescription = exports.metaDescription = 'Serverless functions are written in JavaScript and use the NodeJS runtime. Use them to add new and advanced capabilities to HubSpot CMS websites.';
const position = exports.position = 1;
const toc = exports.toc = [{
  "depth": 0,
  "id": "limits",
  "label": "Limits",
  "parent": null
}, {
  "depth": 1,
  "id": "execution-limits",
  "label": "Execution limits",
  "parent": "limits"
}, {
  "depth": 1,
  "id": "split-dependencies",
  "label": "Split dependencies",
  "parent": "limits"
}, {
  "depth": 0,
  "id": "building-functions",
  "label": "Building functions",
  "parent": null
}, {
  "depth": 1,
  "id": "developer-projects",
  "label": "Developer projects",
  "parent": "building-functions"
}, {
  "depth": 1,
  "id": "design-manager",
  "label": "Design manager",
  "parent": "building-functions"
}, {
  "depth": 0,
  "id": "authentication",
  "label": "Authentication",
  "parent": null
}, {
  "depth": 0,
  "id": "debugging",
  "label": "Debugging",
  "parent": null
}, {
  "depth": 1,
  "id": "project-based-serverless-functions",
  "label": "Project-based serverless functions",
  "parent": "debugging"
}, {
  "depth": 2,
  "id": "in-app-debugging",
  "label": "In-app debugging",
  "parent": "debugging"
}, {
  "depth": 2,
  "id": "local-debugging",
  "label": "Local debugging",
  "parent": "debugging"
}, {
  "depth": 1,
  "id": "design-manager-serverless-functions",
  "label": "Design manager serverless functions",
  "parent": "debugging"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      ul: "ul",
      li: "li",
      h2: "h2",
      code: "code",
      h3: "h3",
      img: "img",
      pre: "pre",
      strong: "strong",
      h4: "h4"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      ProductTier,
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!ProductTier) _missingMdxReference("ProductTier", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Serverless functions for the CMS"
    }), "\n", (0, _jsxRuntime.jsx)(ProductTier, {
      tiers: ['cms-enterprise']
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Serverless functions provide a way to execute JavaScript through HubSpot on the server-side, preventing it from being exposed to the client. This can be especially important for making API requests that contain sensitive information, such as an API key or other credentials. When running a serverless function, HubSpot executes the function on its back-end, which also means you don't need to provide your own back-end servers to make requests for your CMS website. HubSpot’s serverless functions use the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://nodejs.org/en/about/",
        children: "NodeJS"
      }), " runtime."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, you can use serverless functions to:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Collect and store data in HubDB or the HubSpot CRM"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Run complex data calculators"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Dynamically fetch and display data from external systems"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Send form data to external systems"
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Below, learn more about how you can build and use serverless functions on HubSpot's CMS."
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["You may also want to check out the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/content/data-driven-content/serverless-functions/getting-started-with-serverless-functions",
          children: "getting started with serverless functions\nguide"
        }), ",\nas well as the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/serverless-functions",
          children: "serverless functions reference\ndocumentation"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Limits"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Serverless functions are intended to be fast and have a narrow focus. To maintain performance, HubSpot serverless functions are limited to:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "50 secrets per account."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "128MB of memory."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "no more than 100 endpoints per HubSpot account."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["the contentType ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "application/json"
        }), " when calling a function."]
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "6MB per invocation payload, which you might encounter when trying to upload a file with a serverless function, for example."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "4KB for the amount of data that can be logged. When hitting this limit, it's recommended to log after individual actions, rather than the final output."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Execution limits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Each function has a maximum of 10 seconds of execution time."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Each account is limited to 600 total execution seconds per minute."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "This means either of these scenarios can happen within one minute:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Up to 60 function executions that take 10 seconds each to complete."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Up to 6,000 function executions that take 100 milliseconds to complete."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Functions that exceed those limits will throw an error. Execution count and time limits will return a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "429"
      }), " response. The execution time of each function is included in the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#viewing-serverless-function-logs",
        children: "serverless function logs"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Split dependencies"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Serverless functions don't support splitting JavaScript between multiple files, as they cannot import other functions. Instead, your serverless function JavaScript must be contained in one file. Alternatively, you can use ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://webpack.js.org/",
        children: "webpack"
      }), " to bundle your code. Learn more about using webpack as a solution on ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://community.hubspot.com/t5/APIs-Integrations/Import-packages-in-serverless-functions/m-p/346620",
        children: "HubSpot's Community"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Building functions"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Serverless functions consist of a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " directory containing a JavaScript file, a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "serverless.json"
      }), " configuration file, and a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "package.json"
      }), " file. The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " directory can be named anything, as long as it contains the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " suffix. Files stored in this folder are not publicly accessible."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless.json"
        }), ": the serverless function's configuration file, which includes definitions for the function name, JavaScript file path, included secrets, and endpoint details."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: ".js"
        }), " file: the code that gets executed when the function is invoked. This file can have any name, as long as it ends in ", (0, _jsxRuntime.jsx)(_components.code, {
          children: ".js"
        }), ". You'll specify the file name in the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless.json"
        }), " file."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "package.json"
        }), " (project-based only): for serverless functions built with ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/crm/developer-projects/create-a-project",
          children: "projects"
        }), ", this file configures dependencies needed to execute the function."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "There are two methods for building serverless functions and making them available for your CMS website: developer projects and the design manager."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Developer projects"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Using a developer project, you can build and deploy a private app that executes functions when you hit specified endpoints. Using this method, the serverless functions are defined in and managed through the app locally."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "This is the recommended path, as project-based serverless functions enable you to include third-party dependencies, as well as use the private app for HubSpot scopes rather than manually managing app tokens through secrets."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Within a developer project, the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " directory should be placed within the app directory, as shown below."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/project-serverless-functions.png",
        alt: "Directory and file structure of a developer project that includes a serverless function"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "project-folder/\n│── src/\n├──── app\n│     ├── app.json\n│     ├── app.functions/\n│       ├── function.js\n│       ├── package.json\n│       └── serverless.json\n└─ hsproject.json\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Design manager"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "If you've built serverless functions for the CMS before HubSpot's developer projects platform was released, this is the method that you'll have used before. Similar to project-based serverless functions, these serverless functions are built locally, but they're then uploaded to the design manager instead of a project."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["While this method is still supported, including third-party dependencies is ", (0, _jsxRuntime.jsx)("u", {
        children: "not"
      }), " supported, so it's recommended to build serverless functions using projects instead."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For serverless functions created in the design manager, the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " directory is uploaded directly to the design manager using the CLI, not through a developer project. The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: ".functions"
      }), " directory should contain a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "serverless.json"
      }), " file and a JavaScript file containing the code to execute."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/classic-serverless-functions.png",
        alt: "Design manager structure of a classic CMS serverless function"
      })
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "tip",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["For design manager functions, you can prevent accidental edits from within the design manager by locking the folder. To lock a folder, navigate to the design manager, then right-click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "folder"
        }), " and select ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Lock folder"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Authentication"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "There are two ways to authenticate requests made by serverless functions: private app access tokens and secrets."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Private app access tokens:"
        }), " because project-based serverless functions are bundled inside a private app, you can reference the app's access token directly in your JavaScript code. Requests will have access to the scopes assigned to the private app. For serverless functions built in the design manager, you'll need to create a secret to store a private app access token value. Calls authenticated with a private app access token count against your API call limits."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Secrets:"
        }), " create secrets using the CLI to store credentials securely in HubSpot. You can make a secret available to a serverless function by including the secret name in the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless.json"
        }), " file. Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/tools/hubspot-cli/cli-v7",
          children: "managing secrets using the HubSpot CLI"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)("ul", {
        children: [(0, _jsxRuntime.jsx)("li", {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "You should never return secret values through console logging or as a\nresponse, as it will expose the secret to the front-end."
          })
        }), (0, _jsxRuntime.jsx)("li", {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "Due to caching, it can take about one minute to see updated secret values.\nIf you've just updated a secret but are still seeing the old value, check\nagain after about a minute."
          })
        })]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Debugging"
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Project-based serverless functions"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Log messages are produced every time HubSpot executes a serverless function. Below, learn how to access logs in HubSpot and locally using the CLI."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "In-app debugging"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In HubSpot, you can view a serverless function's log history, including successful requests and errors."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To access a serverless function's logs in HubSpot:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In your HubSpot account, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "CRM Development"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the left sidebar menu, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Private apps"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Select the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "private app"
        }), " that contains the serverless function."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Logs"
        }), " tab."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To view logs for a serverless app function, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Serverless functions"
        }), " tab. To view logs for a serverless endpoint function, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Endpoint functions"
        }), " tab."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In each tab, you can view logs for specific requests by clicking the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "request"
        }), ". You can also use the search bar to search by request ID."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the right panel, you can then click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "View log trace"
        }), " for a more in-depth breakdown of the request."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023_2024/view-serverless-app-function-logs.gif",
        alt: "view-serverless-app-function-logs"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can also include ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "console.log()"
      }), " in your serverless function code for debugging purposes, then view its output in the function log details sidebar. Note that the message will not log directly to your browser console."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Local debugging"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Log messages are produced every time HubSpot executes a serverless function. To view a serverless function's logs in the CLI, run the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hs project logs"
      }), " command. Learn more about using the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/crm/developer-projects/project-cli-commands#view-logs",
        children: "hs project logs command"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "There are two types of log messages produced:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Log messages that record the execution of a function, along with its status and timing. For example: ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "2021-04-28T19:19:21.666Z - SUCCESS - Execution Time: 279ms"
        })]
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Log messages that are produced through console statements in the function code. For example, your serverless function JavaScript might include:"
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "exports.main = async (context) => {\n  console.log('Log some debug info');\n  console.error('An error occurred');\n  return {\n    statusCode: 200,\n    body: { message: 'Hello World' },\n  };\n};\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "A log output for the above code would then produce the following:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "2021-04-28T19:15:13.200Z    INFO   Log some debug info"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "2021-04-28T19:15:14.200Z    ERROR    An error occurred"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Design manager serverless functions"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To help with troubleshooting your serverless functions, the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/tools/local-development-cli",
        children: "CLI"
      }), " has an ", (0, _jsxRuntime.jsxs)(_components.a, {
        href: "/guides/cms/tools/local-development-cli#logs",
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "hs logs"
        }), " command"]
      }), " which gives you the ability to view your function’s logs. In addition to individual function invocation responses, time of execution, and execution time, any ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "console.log"
      }), " statement will also appear in function logs. Do not ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "console.log"
      }), " secrets like API keys."]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}